// Add-a-locale recipe — THREE steps, and the middle one is not optional:
//   1. Create `apps/marketing/locales/<loc>.json`. NOT partial: every key en.json
//      carries, or the coverage gate fails (`src/i18n.coverage.test.ts`). A key
//      the file lacks does not throw — `translatorForLocale` merges the locale
//      over the `en` baseline — it silently serves English inside a page whose
//      canonical claims the other language and whose URL is in the sitemap.
//   2. Import it into `CATALOGS` in `apps/marketing/src/i18n.ts`. A STATIC import:
//      that file's docblock records why a runtime `import(\`../locales/${loc}.json\`)
//      cannot work — the Vite SSR bundle fails to resolve the template at runtime,
//      so every `/es` render degraded to en IN THE BUILT SITE while `bun test`
//      stayed green.
//   3. Append `'<loc>'` to SUPPORTED_LOCALES below.
//
// This comment used to say "two steps, no code changes beyond this file" and omit
// step 2. Following it registers the locale, emits its canonicals and lists them
// in the sitemap — and serves English from all of them, in the built site only,
// with the suite green. That is the bug described in step 2, which shipped once
// already; a recipe that reproduces it is worse than no recipe.
//
// Route middleware in apps/marketing (src/server/) parses the locale prefix from
// the URL and calls `translatorFor(locale)` — hreflang + canonical are emitted
// automatically (src/seo/canonical.ts) once the locale is recognised here.
export const SUPPORTED_LOCALES = ['en', 'es', 'zh'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export function isLocale(value: string): value is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
